import { render } from "./UseinfoButtonSticky.vue?vue&type=template&id=f67661ea&scoped=true&ts=true"
import script from "./UseinfoButtonSticky.vue?vue&type=script&lang=ts"
export * from "./UseinfoButtonSticky.vue?vue&type=script&lang=ts"

import "./UseinfoButtonSticky.vue?vue&type=style&index=0&id=f67661ea&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f67661ea"]])

export default __exports__